import Caption from 'LuxKit/Typography/Caption'
import Group from 'components/utils/Group'
import { useIntl } from 'react-intl'

type Props = {
  offer: App.VillaOffer | App.VillaOfferSummary
  locationHeading?: string
  locationSubheading?: string
}

function VillaLocationCaption(props: Props) {
  const { offer } = props
  const intl = useIntl()

  const locationLabel = offer.locationHeading && offer.locationSubheading
    ? intl.formatMessage(
        {
          id: 'A5196XNeUNl5D3jlIcF5',
          defaultMessage: '{locationHeading}, {locationSubheading}',
          description: 'Villa offer card location heading and subheading separated by comma',
        },
        { locationHeading: offer.locationHeading, locationSubheading: offer.locationSubheading },
      )
    : (offer.locationHeading || offer.locationSubheading)

  return (
    <Group direction="horizontal" gap={4}>
      <Caption colour="light-foreground-alt" variant="large">
        {locationLabel}
      </Caption>
      <Caption variant="large" colour="light-foreground-alt">
        {intl.formatMessage({
          id: 'MbCDyGbKuswd1AJvDVgv',
          defaultMessage: '· Villa',
          description: 'Dot separator followed by property type label for villa offer cards',
        })}
      </Caption>
    </Group>
  )
}

export default VillaLocationCaption
